import { TestComponent } from './test/test.component';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { NgModule } from '@angular/core';
// import { PaymentPageComponent } from './payment-page/payment-page.component';
// import { EventsListPageComponent } from './events-list-page/events-list-page.component';
// import { AboutPageComponent } from './about-page/about-page.component';
// import { MembershipFormComponent } from './membership-form/membership-form.component';
// import { SignUpComponent } from './sign-up/sign-up.component';
// import { StudentBranchesPageComponent } from './student-branches-page/student-branches-page.component';
// import { ContactUsPageComponent } from './contact-us-page/contact-us-page.component';
// import { HomeComponent } from './home/home.component';
// import { BlogComponent } from './blog/blog.component';
// import { ArticleComponent } from './article/article.component';
// import { StudentBranchDetailsComponent } from './student-branch-details/student-branch-details.component';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};


const routes: Routes = [
  { 
    path: '',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'test',
    component: TestComponent
  }

  // { path: 'home', component: HomeComponent },
  // { path: 'contact-us', component: ContactUsPageComponent },
  // { path: 'student-branches', component: StudentBranchesPageComponent},
  // { path: 'blog', component: BlogComponent},
  // { path: 'blog/:article', component: ArticleComponent},
  // { path: 'student-branches/:studentBranch', component: StudentBranchDetailsComponent},
  // { path: 'sign-up', component: SignUpComponent},
  // { path: 'membership', component: MembershipFormComponent},
  // { path: 'about-us', component: AboutPageComponent},
  // { path: 'events-list', component: EventsListPageComponent},
  // { path: 'payment', component: PaymentPageComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
